"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importDefault(require("react"));
var Slide1_1 = __importDefault(require("./Slide1"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var InFooterCompanies = function (_a) {
    var _b = _a.withDividedLines, withDividedLines = _b === void 0 ? false : _b;
    var t = (0, next_intl_1.useTranslations)('translation');
    var globalConfig = (0, swr_hooks_1.useConfig)();
    if (globalConfig === null || globalConfig === void 0 ? void 0 : globalConfig.oneDepositMethodOnly)
        return null;
    return (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.wrapper, " footer-companies") },
        react_1.default.createElement("h2", { className: styles_module_scss_1.default.title }, t('chooseYourSecurePaymentMethod')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement(Slide1_1.default, null)),
        react_1.default.createElement(ui_components_1.DividedLine, null)));
};
exports.default = InFooterCompanies;
